import apiClient from '../../../helpers/axiosHelper';
import axiosInstance from '../../../helpers/axiosConfig';
import config from '../../../config';

export const getTrainingData = async () =>{
    const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL

    try {
        const response = await axiosInstance.get(`${baseUrl}Enrollment/EnrollmentType?EnrollmentType=TPATraining`)
  
        //console.log('getTrainingData: ', response)
        return response
      } catch (error) {
        // console.error('Register catch Error:', error)
        throw error
      }
}


export const UserInfo = async () => {
    const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access-token')}`
      };


    try {
        const data = await axiosInstance.get(`${baseUrl}Member/UserInfo`, { headers })

    if ( data) {

        //console.log('data userInfo service: ', data)
        return data
    }
    } catch (error) {
        // console.error('Register catch Error:', error)
    }

    
}

export const ExtraUrls = async () => {
    const baseUrl = config.REACT_APP_BASE_URL

    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access-token')}`
      };

    try {
        const response = await axiosInstance.get(`${baseUrl}Menu/ExtraUrls`, { headers })
  
        // console.log('getExtraUrl: ', response)
        return response
      } catch (error) {
         console.error('Register catch Error:', error)
        throw error
      }
}

